import React from "react";
import { useAppSelector } from "../../../../../app/hooks";
import { CNYProps, FormInputs } from "../../../../../types/walletTypes";
import { CountryConfig } from "../types";

interface GenericReviewProps extends CNYProps {
  config: CountryConfig;
}

const Review: React.FC<GenericReviewProps> = ({ handleNext, handlePrevious, config }) => {
  const countryKey = (config.dataSliceKey || config.code).toLowerCase();
  const asiaPayoutData = useAppSelector((state) => (state.formData as any)?.asiaPayoutData);
  const getSavedData: FormInputs = asiaPayoutData?.[countryKey] || {};

  const paymentMethod = getSavedData?.paymentMethod;

  const ReviewComponent =
    config.formRegistry.review?.[paymentMethod] ||
    config.formRegistry.review?.default;

  if (!ReviewComponent) return null
  
  return (
    <ReviewComponent
      handleNext={handleNext}
      handlePrevious={handlePrevious}
      config={config}
    />
  );
};

export default Review;
